export const Experiment = {
  AshbyIntegration: "20230704_ASHBY_ATS_INTEGRATION",
  BooleanSearch: "20240626_HIRE_APP_BOOLEAN_SEARCH",
} as const;
